// source: image.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var device_type_pb = require('./device_type_pb.js');
goog.object.extend(proto, device_type_pb);
goog.exportSymbol('proto.pb.Image', null, global);
goog.exportSymbol('proto.pb.Image.Status', null, global);
goog.exportSymbol('proto.pb.ImageCredentials', null, global);
goog.exportSymbol('proto.pb.WorkerImage', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.Image = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pb.Image.repeatedFields_, null);
};
goog.inherits(proto.pb.Image, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.Image.displayName = 'proto.pb.Image';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.WorkerImage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pb.WorkerImage.repeatedFields_, null);
};
goog.inherits(proto.pb.WorkerImage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.WorkerImage.displayName = 'proto.pb.WorkerImage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.ImageCredentials = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.ImageCredentials, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.ImageCredentials.displayName = 'proto.pb.ImageCredentials';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pb.Image.repeatedFields_ = [12,13,14];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.Image.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.Image.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.Image} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.Image.toObject = function(includeInstance, msg) {
  var f, obj = {
    imageid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    type: jspb.Message.getFieldWithDefault(msg, 2, 0),
    plantfolder: jspb.Message.getFieldWithDefault(msg, 3, ""),
    plantid: jspb.Message.getFieldWithDefault(msg, 4, ""),
    siteid: jspb.Message.getFieldWithDefault(msg, 5, ""),
    templateid: jspb.Message.getFieldWithDefault(msg, 6, ""),
    os: jspb.Message.getFieldWithDefault(msg, 7, ""),
    sourceimage: jspb.Message.getFieldWithDefault(msg, 8, ""),
    remotemanagement: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    remoteaccess: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    remoteaccessport: jspb.Message.getFieldWithDefault(msg, 11, 0),
    packageversionsList: (f = jspb.Message.getRepeatedField(msg, 12)) == null ? undefined : f,
    devicemodelsList: (f = jspb.Message.getRepeatedField(msg, 13)) == null ? undefined : f,
    deviceidxsList: (f = jspb.Message.getRepeatedField(msg, 14)) == null ? undefined : f,
    devices: jspb.Message.getFieldWithDefault(msg, 15, 0),
    owner: jspb.Message.getFieldWithDefault(msg, 16, ""),
    modifiedby: jspb.Message.getFieldWithDefault(msg, 17, ""),
    lastmodified: jspb.Message.getFieldWithDefault(msg, 18, 0),
    status: jspb.Message.getFieldWithDefault(msg, 19, 0),
    error: jspb.Message.getFieldWithDefault(msg, 20, ""),
    size: jspb.Message.getFieldWithDefault(msg, 21, 0),
    etag: jspb.Message.getFieldWithDefault(msg, 22, ""),
    hash: jspb.Message.getFieldWithDefault(msg, 23, ""),
    invalid: jspb.Message.getBooleanFieldWithDefault(msg, 24, false),
    deleted: jspb.Message.getBooleanFieldWithDefault(msg, 25, false),
    unityrelease: jspb.Message.getFieldWithDefault(msg, 26, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.Image}
 */
proto.pb.Image.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.Image;
  return proto.pb.Image.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.Image} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.Image}
 */
proto.pb.Image.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setImageid(value);
      break;
    case 2:
      var value = /** @type {!proto.pb.DeviceType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlantfolder(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlantid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setTemplateid(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setOs(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceimage(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRemotemanagement(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRemoteaccess(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRemoteaccessport(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.addPackageversions(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.addDevicemodels(value);
      break;
    case 14:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addDeviceidxs(values[i]);
      }
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDevices(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setOwner(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setModifiedby(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLastmodified(value);
      break;
    case 19:
      var value = /** @type {!proto.pb.Image.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setError(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSize(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setEtag(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setHash(value);
      break;
    case 24:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setInvalid(value);
      break;
    case 25:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDeleted(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnityrelease(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.Image.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.Image.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.Image} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.Image.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getImageid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getPlantfolder();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPlantid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSiteid();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getTemplateid();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getOs();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getSourceimage();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getRemotemanagement();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getRemoteaccess();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getRemoteaccessport();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getPackageversionsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      12,
      f
    );
  }
  f = message.getDevicemodelsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      13,
      f
    );
  }
  f = message.getDeviceidxsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      14,
      f
    );
  }
  f = message.getDevices();
  if (f !== 0) {
    writer.writeInt32(
      15,
      f
    );
  }
  f = message.getOwner();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getModifiedby();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getLastmodified();
  if (f !== 0) {
    writer.writeInt64(
      18,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      19,
      f
    );
  }
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getSize();
  if (f !== 0) {
    writer.writeInt64(
      21,
      f
    );
  }
  f = message.getEtag();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getHash();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getInvalid();
  if (f) {
    writer.writeBool(
      24,
      f
    );
  }
  f = message.getDeleted();
  if (f) {
    writer.writeBool(
      25,
      f
    );
  }
  f = message.getUnityrelease();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.pb.Image.Status = {
  PENDING: 0,
  RUNNING: 1,
  DONE: 2,
  FAILED: 3,
  TIMEOUT: 4
};

/**
 * optional string ImageID = 1;
 * @return {string}
 */
proto.pb.Image.prototype.getImageid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.Image} returns this
 */
proto.pb.Image.prototype.setImageid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional DeviceType Type = 2;
 * @return {!proto.pb.DeviceType}
 */
proto.pb.Image.prototype.getType = function() {
  return /** @type {!proto.pb.DeviceType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.pb.DeviceType} value
 * @return {!proto.pb.Image} returns this
 */
proto.pb.Image.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string PlantFolder = 3;
 * @return {string}
 */
proto.pb.Image.prototype.getPlantfolder = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.Image} returns this
 */
proto.pb.Image.prototype.setPlantfolder = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string PlantID = 4;
 * @return {string}
 */
proto.pb.Image.prototype.getPlantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.Image} returns this
 */
proto.pb.Image.prototype.setPlantid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string SiteID = 5;
 * @return {string}
 */
proto.pb.Image.prototype.getSiteid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.Image} returns this
 */
proto.pb.Image.prototype.setSiteid = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string TemplateID = 6;
 * @return {string}
 */
proto.pb.Image.prototype.getTemplateid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.Image} returns this
 */
proto.pb.Image.prototype.setTemplateid = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string OS = 7;
 * @return {string}
 */
proto.pb.Image.prototype.getOs = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.Image} returns this
 */
proto.pb.Image.prototype.setOs = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string SourceImage = 8;
 * @return {string}
 */
proto.pb.Image.prototype.getSourceimage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.Image} returns this
 */
proto.pb.Image.prototype.setSourceimage = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional bool RemoteManagement = 9;
 * @return {boolean}
 */
proto.pb.Image.prototype.getRemotemanagement = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pb.Image} returns this
 */
proto.pb.Image.prototype.setRemotemanagement = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional bool RemoteAccess = 10;
 * @return {boolean}
 */
proto.pb.Image.prototype.getRemoteaccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pb.Image} returns this
 */
proto.pb.Image.prototype.setRemoteaccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional int32 RemoteAccessPort = 11;
 * @return {number}
 */
proto.pb.Image.prototype.getRemoteaccessport = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.pb.Image} returns this
 */
proto.pb.Image.prototype.setRemoteaccessport = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * repeated string PackageVersions = 12;
 * @return {!Array<string>}
 */
proto.pb.Image.prototype.getPackageversionsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 12));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pb.Image} returns this
 */
proto.pb.Image.prototype.setPackageversionsList = function(value) {
  return jspb.Message.setField(this, 12, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pb.Image} returns this
 */
proto.pb.Image.prototype.addPackageversions = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 12, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pb.Image} returns this
 */
proto.pb.Image.prototype.clearPackageversionsList = function() {
  return this.setPackageversionsList([]);
};


/**
 * repeated string DeviceModels = 13;
 * @return {!Array<string>}
 */
proto.pb.Image.prototype.getDevicemodelsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 13));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pb.Image} returns this
 */
proto.pb.Image.prototype.setDevicemodelsList = function(value) {
  return jspb.Message.setField(this, 13, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pb.Image} returns this
 */
proto.pb.Image.prototype.addDevicemodels = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 13, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pb.Image} returns this
 */
proto.pb.Image.prototype.clearDevicemodelsList = function() {
  return this.setDevicemodelsList([]);
};


/**
 * repeated int32 DeviceIDXs = 14;
 * @return {!Array<number>}
 */
proto.pb.Image.prototype.getDeviceidxsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 14));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.pb.Image} returns this
 */
proto.pb.Image.prototype.setDeviceidxsList = function(value) {
  return jspb.Message.setField(this, 14, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.pb.Image} returns this
 */
proto.pb.Image.prototype.addDeviceidxs = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 14, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pb.Image} returns this
 */
proto.pb.Image.prototype.clearDeviceidxsList = function() {
  return this.setDeviceidxsList([]);
};


/**
 * optional int32 Devices = 15;
 * @return {number}
 */
proto.pb.Image.prototype.getDevices = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.pb.Image} returns this
 */
proto.pb.Image.prototype.setDevices = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional string Owner = 16;
 * @return {string}
 */
proto.pb.Image.prototype.getOwner = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.Image} returns this
 */
proto.pb.Image.prototype.setOwner = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string ModifiedBy = 17;
 * @return {string}
 */
proto.pb.Image.prototype.getModifiedby = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.Image} returns this
 */
proto.pb.Image.prototype.setModifiedby = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional int64 LastModified = 18;
 * @return {number}
 */
proto.pb.Image.prototype.getLastmodified = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.pb.Image} returns this
 */
proto.pb.Image.prototype.setLastmodified = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional Status status = 19;
 * @return {!proto.pb.Image.Status}
 */
proto.pb.Image.prototype.getStatus = function() {
  return /** @type {!proto.pb.Image.Status} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {!proto.pb.Image.Status} value
 * @return {!proto.pb.Image} returns this
 */
proto.pb.Image.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 19, value);
};


/**
 * optional string Error = 20;
 * @return {string}
 */
proto.pb.Image.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.Image} returns this
 */
proto.pb.Image.prototype.setError = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional int64 Size = 21;
 * @return {number}
 */
proto.pb.Image.prototype.getSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {number} value
 * @return {!proto.pb.Image} returns this
 */
proto.pb.Image.prototype.setSize = function(value) {
  return jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * optional string ETag = 22;
 * @return {string}
 */
proto.pb.Image.prototype.getEtag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.Image} returns this
 */
proto.pb.Image.prototype.setEtag = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional string Hash = 23;
 * @return {string}
 */
proto.pb.Image.prototype.getHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.Image} returns this
 */
proto.pb.Image.prototype.setHash = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional bool Invalid = 24;
 * @return {boolean}
 */
proto.pb.Image.prototype.getInvalid = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 24, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pb.Image} returns this
 */
proto.pb.Image.prototype.setInvalid = function(value) {
  return jspb.Message.setProto3BooleanField(this, 24, value);
};


/**
 * optional bool Deleted = 25;
 * @return {boolean}
 */
proto.pb.Image.prototype.getDeleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 25, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pb.Image} returns this
 */
proto.pb.Image.prototype.setDeleted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 25, value);
};


/**
 * optional string UnityRelease = 26;
 * @return {string}
 */
proto.pb.Image.prototype.getUnityrelease = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.Image} returns this
 */
proto.pb.Image.prototype.setUnityrelease = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pb.WorkerImage.repeatedFields_ = [2,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.WorkerImage.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.WorkerImage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.WorkerImage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.WorkerImage.toObject = function(includeInstance, msg) {
  var f, obj = {
    image: (f = msg.getImage()) && proto.pb.Image.toObject(includeInstance, f),
    deviceidsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    credentials: (f = msg.getCredentials()) && proto.pb.ImageCredentials.toObject(includeInstance, f),
    supportedmodelsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.WorkerImage}
 */
proto.pb.WorkerImage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.WorkerImage;
  return proto.pb.WorkerImage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.WorkerImage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.WorkerImage}
 */
proto.pb.WorkerImage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pb.Image;
      reader.readMessage(value,proto.pb.Image.deserializeBinaryFromReader);
      msg.setImage(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addDeviceids(value);
      break;
    case 3:
      var value = new proto.pb.ImageCredentials;
      reader.readMessage(value,proto.pb.ImageCredentials.deserializeBinaryFromReader);
      msg.setCredentials(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addSupportedmodels(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.WorkerImage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.WorkerImage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.WorkerImage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.WorkerImage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getImage();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pb.Image.serializeBinaryToWriter
    );
  }
  f = message.getDeviceidsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getCredentials();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.pb.ImageCredentials.serializeBinaryToWriter
    );
  }
  f = message.getSupportedmodelsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
};


/**
 * optional Image image = 1;
 * @return {?proto.pb.Image}
 */
proto.pb.WorkerImage.prototype.getImage = function() {
  return /** @type{?proto.pb.Image} */ (
    jspb.Message.getWrapperField(this, proto.pb.Image, 1));
};


/**
 * @param {?proto.pb.Image|undefined} value
 * @return {!proto.pb.WorkerImage} returns this
*/
proto.pb.WorkerImage.prototype.setImage = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pb.WorkerImage} returns this
 */
proto.pb.WorkerImage.prototype.clearImage = function() {
  return this.setImage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pb.WorkerImage.prototype.hasImage = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated string DeviceIDs = 2;
 * @return {!Array<string>}
 */
proto.pb.WorkerImage.prototype.getDeviceidsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pb.WorkerImage} returns this
 */
proto.pb.WorkerImage.prototype.setDeviceidsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pb.WorkerImage} returns this
 */
proto.pb.WorkerImage.prototype.addDeviceids = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pb.WorkerImage} returns this
 */
proto.pb.WorkerImage.prototype.clearDeviceidsList = function() {
  return this.setDeviceidsList([]);
};


/**
 * optional ImageCredentials Credentials = 3;
 * @return {?proto.pb.ImageCredentials}
 */
proto.pb.WorkerImage.prototype.getCredentials = function() {
  return /** @type{?proto.pb.ImageCredentials} */ (
    jspb.Message.getWrapperField(this, proto.pb.ImageCredentials, 3));
};


/**
 * @param {?proto.pb.ImageCredentials|undefined} value
 * @return {!proto.pb.WorkerImage} returns this
*/
proto.pb.WorkerImage.prototype.setCredentials = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pb.WorkerImage} returns this
 */
proto.pb.WorkerImage.prototype.clearCredentials = function() {
  return this.setCredentials(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pb.WorkerImage.prototype.hasCredentials = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated string SupportedModels = 4;
 * @return {!Array<string>}
 */
proto.pb.WorkerImage.prototype.getSupportedmodelsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pb.WorkerImage} returns this
 */
proto.pb.WorkerImage.prototype.setSupportedmodelsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pb.WorkerImage} returns this
 */
proto.pb.WorkerImage.prototype.addSupportedmodels = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pb.WorkerImage} returns this
 */
proto.pb.WorkerImage.prototype.clearSupportedmodelsList = function() {
  return this.setSupportedmodelsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.ImageCredentials.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.ImageCredentials.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.ImageCredentials} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.ImageCredentials.toObject = function(includeInstance, msg) {
  var f, obj = {
    imageid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    rootpassword: jspb.Message.getFieldWithDefault(msg, 2, ""),
    fieldhubpassword: jspb.Message.getFieldWithDefault(msg, 3, ""),
    plantid: jspb.Message.getFieldWithDefault(msg, 4, ""),
    owner: jspb.Message.getFieldWithDefault(msg, 5, ""),
    modifiedby: jspb.Message.getFieldWithDefault(msg, 6, ""),
    lastmodified: jspb.Message.getFieldWithDefault(msg, 7, 0),
    deleted: jspb.Message.getBooleanFieldWithDefault(msg, 8, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.ImageCredentials}
 */
proto.pb.ImageCredentials.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.ImageCredentials;
  return proto.pb.ImageCredentials.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.ImageCredentials} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.ImageCredentials}
 */
proto.pb.ImageCredentials.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setImageid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRootpassword(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFieldhubpassword(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlantid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setOwner(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setModifiedby(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLastmodified(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDeleted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.ImageCredentials.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.ImageCredentials.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.ImageCredentials} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.ImageCredentials.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getImageid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRootpassword();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFieldhubpassword();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPlantid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getOwner();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getModifiedby();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getLastmodified();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getDeleted();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
};


/**
 * optional string ImageID = 1;
 * @return {string}
 */
proto.pb.ImageCredentials.prototype.getImageid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.ImageCredentials} returns this
 */
proto.pb.ImageCredentials.prototype.setImageid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string RootPassword = 2;
 * @return {string}
 */
proto.pb.ImageCredentials.prototype.getRootpassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.ImageCredentials} returns this
 */
proto.pb.ImageCredentials.prototype.setRootpassword = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string FieldHubPassword = 3;
 * @return {string}
 */
proto.pb.ImageCredentials.prototype.getFieldhubpassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.ImageCredentials} returns this
 */
proto.pb.ImageCredentials.prototype.setFieldhubpassword = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string PlantID = 4;
 * @return {string}
 */
proto.pb.ImageCredentials.prototype.getPlantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.ImageCredentials} returns this
 */
proto.pb.ImageCredentials.prototype.setPlantid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Owner = 5;
 * @return {string}
 */
proto.pb.ImageCredentials.prototype.getOwner = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.ImageCredentials} returns this
 */
proto.pb.ImageCredentials.prototype.setOwner = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string ModifiedBy = 6;
 * @return {string}
 */
proto.pb.ImageCredentials.prototype.getModifiedby = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.ImageCredentials} returns this
 */
proto.pb.ImageCredentials.prototype.setModifiedby = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int64 LastModified = 7;
 * @return {number}
 */
proto.pb.ImageCredentials.prototype.getLastmodified = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.pb.ImageCredentials} returns this
 */
proto.pb.ImageCredentials.prototype.setLastmodified = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional bool Deleted = 8;
 * @return {boolean}
 */
proto.pb.ImageCredentials.prototype.getDeleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pb.ImageCredentials} returns this
 */
proto.pb.ImageCredentials.prototype.setDeleted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


goog.object.extend(exports, proto.pb);
